import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        const t = localStorage.getItem("bdo_access");
        if (!t) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("bdo_access", data.access_token);
        localStorage.setItem("bdo_refresh", data.refresh_token);
        await fetchMe();
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        return data;
    };

    const verify = async (token) => {
        return (await api.post("/auth/verify-email", { token })).data;
    };

    const logout = async () => {
        const rt = localStorage.getItem("bdo_refresh");
        try {
            if (rt) await api.post("/auth/logout", { refresh_token: rt });
        } catch {
            /* ignore */
        }
        localStorage.removeItem("bdo_access");
        localStorage.removeItem("bdo_refresh");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, register, verify, logout, refresh: fetchMe }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
